export default __webpack_public_path__ + "static/media/dragos-rizescu.94ff3cac.png";